import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import ClampedMultiLineText from 'dpl/common/components/ClampedMultiLineText';
import ImagePlaceholder from 'dpl/components/MediaGrid/ImagePlaceholder';
import SmartImage from 'dpl/components/SmartImage';
import { GENDERS } from 'dpl/shared/constants/breeder_app';

import ParentHealthTestingDescription from './ParentDogsHealthTestingDescription';

export default function ParentDogCard({ className, dog, isInnerTooltip }) {
  const parentTitle = dog.gender === GENDERS.FEMALE ? 'mom' : 'dad';

  return (
    <div
      className={classnames(
        'ParentDogCard bg-white br4 ba b--default pt2 ph2',
        className
      )}
    >
      <div className="aspect-ratio--8x5 relative">
        <div className="aspect-ratio--object">
          {dog.profile_photo_url ? (
            <SmartImage
              Tag="div"
              className="br3 w-100 h-100 cover bg-center"
              loadingClass="bg-light-gray"
              src={dog.profile_photo_url}
              crop
              lazy
            />
          ) : (
            <ImagePlaceholder className="br3" />
          )}
        </div>
      </div>
      <div className="pv4 ph2">
        <h6 className="font-20 lh-title mb1">
          {dog.name}, {parentTitle}
        </h6>
        <p className="secondary font-16">{dog.breed_name}</p>
        <div className="mt4 font-16">
          <p className="fw-medium mb2">About {dog.name}</p>
          <ClampedMultiLineText
            className="secondary lh-body"
            numOfLines={4}
            lineHeight={22.4}
            text={dog.description}
            moreText="Read more"
            lessText="Show less"
            moreButtonClassName="stone-700"
            fadeToButton
            isOpen={window.__DPL_BOT_UA}
          />
        </div>
        {dog.health_testing.documented_health_tests.length > 0 && (
          <ParentHealthTestingDescription
            dog={dog}
            isInnerTooltip={isInnerTooltip}
          />
        )}
      </div>
    </div>
  );
}

ParentDogCard.propTypes = {
  className: PropTypes.string,
  dog: PropTypes.shape({
    breed_name: PropTypes.string,
    description: PropTypes.string,
    gender: PropTypes.oneOf(Object.values(GENDERS)),
    health_testing: PropTypes.shape({
      title: PropTypes.string,
      documented_health_tests: PropTypes.arrayOf(PropTypes.string)
    }),
    health_tier_title: PropTypes.string,
    health_test_results_public: PropTypes.bool,
    health_test_results: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        description: PropTypes.string,
        health_test_id: PropTypes.number,
        health_test_name: PropTypes.string,
        health_test_result_documents: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.number,
            is_file: PropTypes.bool,
            name: PropTypes.string,
            url: PropTypes.string
          })
        )
      })
    ),
    name: PropTypes.string,
    profile_photo_url: PropTypes.string
  }).isRequired,
  isInnerTooltip: PropTypes.bool
};

ParentDogCard.defaultProps = {
  className: null,
  isInnerTooltip: false
};
